import { render, staticRenderFns } from "./jobMatching.vue?vue&type=template&id=6b42781c&scoped=true&"
import script from "./jobMatching.vue?vue&type=script&lang=js&"
export * from "./jobMatching.vue?vue&type=script&lang=js&"
import style0 from "./jobMatching.vue?vue&type=style&index=0&id=6b42781c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42781c",
  null
  
)

export default component.exports